/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Show_AvatarInputs */

const nl_rapporten_config_elements_show_avatar = /** @type {(inputs: Rapporten_Config_Elements_Show_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toon avatar`)
};

/**

* @param {Rapporten_Config_Elements_Show_AvatarInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_show_avatar = /** @type {((inputs?: Rapporten_Config_Elements_Show_AvatarInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Show_AvatarInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_show_avatar(inputs)
});
export { rapporten_config_elements_show_avatar as "rapporten.config.elements.show_avatar" }